export const Logo = ({ dark = false, compact = false }) => (
  <span className="inline-flex items-center gap-2.5" data-testid="dpa-logo">
    <img
      src="/logo.png"
      alt="Digital Product Academy logo"
      className="h-9 w-9 rounded-xl object-cover shadow-[0_6px_16px_-4px_rgba(124,58,237,0.5)] ring-1 ring-[#7C3AED]/30"
    />
    {!compact && (
      <span className="leading-none">
        <span className={`block text-[15px] font-extrabold tracking-tight ${dark ? "text-white" : "text-[#171321]"}`}>
          DPA
        </span>
        <span className={`block text-[10px] font-semibold tracking-wide ${dark ? "text-[#B8B1C8]" : "text-[#777181]"}`}>
          Digital Product Academy
        </span>
      </span>
    )}
  </span>
);
